import { useModals } from "@/router"

export default function PolitiqueConfidentialite() {

    const modals = useModals()

    const handleClose = () => modals.close()

    return (
    <div className="fixed inset-0 place-items-center bg-black/25 md:mt-[72px] md:ml-64 md:p-10 overflow-auto z-50">
      
      <div className="relative flex w-full md:max-w-5xl flex-col rounded-lg border border-slate-500 bg-white p-10">
        
        
        <h1 className="text-3xl font-bold mb-6">Politique de confidentialité et de gestion des données personnelles</h1>

        <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">1. Introduction</h2>
        <p>
            La présente politique de confidentialité a pour objectif de vous informer sur la manière dont l’association <strong>Worldskills France</strong> collecte, utilise, stocke et protège vos données personnelles dans le cadre de l’utilisation du forum interne de discussion accessible à l’adresse <strong>https://forum.worldskills-france.org</strong>.
        </p>
        <p className="mt-2">Ce forum est réservé aux membres et bénévoles de l’association. Aucun accès public n’est possible.</p>
        </section>

        <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">2. Responsable du traitement</h2>
        <p>
            Le responsable du traitement des données est :<br />
            <strong>Référent RGPD WorldSkills France</strong><br />
            Adresse : 15 - 17 rue Traversière, 75012 Paris, France<br />
            Email : <a href="mailto:rsi@cofom.org">rsi@cofom.org</a>
        </p>
        </section>

        <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">3. Données collectées</h2>
        <ul className="list-disc list-inside space-y-1">
            <li>Nom et prénom</li>
            <li>Adresse email (personnelle ou professionnelle)</li>
            <li>Photo de profil (le cas échéant)</li>
            <li>Données d’identification (identifiants de connexion)</li>
            <li>Historique des messages postés sur le forum</li>
        </ul>
        <p className="mt-2">Aucune donnée sensible (au sens du RGPD) n’est collectée.</p>
        </section>

        <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">4. Finalités du traitement</h2>
        <p>Les données personnelles sont traitées exclusivement pour les finalités suivantes :</p>
        <ul className="list-disc list-inside space-y-1 mt-2">
            <li>Création, gestion et sécurisation des comptes utilisateurs</li>
            <li>Accès restreint au forum de discussion interne</li>
            <li>Affichage des informations de profil dans les échanges entre membres</li>
            <li>Suivi de l’activité sur le forum à des fins de modération et d’administration</li>
        </ul>
        </section>

        <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">5. Base légale du traitement</h2>
        <p>Le traitement de vos données personnelles repose sur :</p>
        <ul className="list-disc list-inside space-y-1 mt-2">
            <li><strong>L’intérêt légitime</strong> de l’association à organiser et gérer ses échanges internes entre bénévoles et membres actifs</li>
            <li><strong>Votre consentement</strong>, exprimé lors de la création de votre compte et de l’acceptation de cette politique</li>
        </ul>
        </section>

        <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">6. Hébergement et stockage des données</h2>
        <p>
            L’ensemble des données personnelles sont <strong>stockées exclusivement sur des serveurs situés en France</strong>.
            Aucune donnée ne quitte ce territoire ni n’est transmise à des tiers à des fins commerciales ou publicitaires.
        </p>
        </section>

        <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">7. Sécurité</h2>
        <p>Des mesures techniques et organisationnelles appropriées sont mises en œuvre afin de garantir la confidentialité, l’intégrité et la disponibilité de vos données :</p>
        <ul className="list-disc list-inside space-y-1 mt-2">
            <li>Chiffrement des connexions (HTTPS)</li>
            <li>Accès restreint au serveur et authentification forte des administrateurs</li>
            <li>Sauvegardes régulières</li>
        </ul>
        </section>

        <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">8. Durée de conservation</h2>
        <p>
            Vos données personnelles sont conservées :
        </p>
        <ul className="list-disc list-inside space-y-1 mt-2">
            <li>Tant que votre compte utilisateur est actif</li>
            <li>Et jusqu’à 12 mois après votre dernier accès, sauf obligation légale contraire</li>
        </ul>
        <p className="mt-2">Vous pouvez à tout moment demander la suppression de votre compte et de vos données associées.</p>
        </section>

        <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">9. Vos droits</h2>
        <p>Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez des droits suivants :</p>
        <ul className="list-disc list-inside space-y-1 mt-2">
            <li>Droit d’accès à vos données personnelles</li>
            <li>Droit de rectification</li>
            <li>Droit à l’effacement (droit à l’oubli)</li>
            <li>Droit à la limitation du traitement</li>
            <li>Droit d’opposition</li>
            <li>Droit à la portabilité des données</li>
        </ul>
        <p className="mt-2">Pour exercer ces droits, veuillez nous contacter à : <strong>rsi@cofom.org</strong></p>
        <p className="mt-2 font-bold">Dans le cas où vous souhaitez supprimer vos données personnelles, 
            vous vous privez consciemment d&apos;un droit d&apos;accès aux ressources de préparation de la compétition à laquelle vous devez participer 
            et vous ne pourrez faire valoir un manque d&apos;information sur un éventuel litige qui surviendrait ultérieurement.</p>
        </section>

        <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">10. Modifications de la politique</h2>
        <p>
            Cette politique de confidentialité peut être mise à jour à tout moment. Toute modification substantielle vous sera notifiée lors de votre prochaine connexion au forum.
        </p>
        </section>

        <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">11. Contact</h2>
        <p>
            Pour toute question concernant cette politique de confidentialité ou vos données personnelles, vous pouvez nous contacter à :<br />
            <strong>Référent RGPD, Worldskills France</strong> – rsi@cofom.org – 15-17 rue Traversière, 75012 Paris, France
        </p>
        </section>


        <div className="mt-auto flex justify-end">
          <button className="text-sm font-semibold" onClick={() => modals.close()}>
            Fermer
          </button>
        </div>

        <div className="absolute inset-0 -z-10" onClick={handleClose} />
      </div>
    </div>
    )
}